import { Injectable } from "@angular/core";
import { URLS } from '../../../config/api.config';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { environment } from "../../../environments/environment";
import { CommonService } from "../../helpers/common.service";
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { map } from 'rxjs/operators';
import moment from 'moment';
import { StorageServiceAAA } from "../../helpers/aaa-storage.service";
import { CustomEncryption } from "../../../config/custom-encrypt";

interface ParamsBody {
	LoginId: string;
	Reason?: string;  // Optional property for Reason
	ClientCode?: string; 
	SearchBy?: string,
	Searchtext?: string,
	FromDate?:any,
	ToDate?:any // Optional property for ClientCode
	LoginID? : any
  }
  
@Injectable()
export class WireRequestService {

private revenueAssumptions = URLS.revenueAssumptions;
private revenueCalculator = URLS.revenueCalculator;
private saveRevenueSimulation = URLS.saveRevenueSimulation;
private fetchRevenueTracker = URLS.fetchRevenueTracker;
private RevenueTrackerDetail = URLS.RevenueTrackerDetail;
private limitReqStatus = URLS.limitReqStatus;
private jvReqStatus = URLS.jvReqStatus;
private epiReqStatus = URLS.epiReqStatus;
private clientCodes = URLS.clientCodesList;
private limitRequest = URLS.limitInsert;
private limitValidate = URLS.limitValidate;
private jvValidate = URLS.jvValidate;
private jvInsert = URLS.jvInsert;
private brokerageApproval = URLS.brokerageApprove;
private brokergeRequest = URLS.brokergeRequest;
private brokergeRequestV1 = URLS.brokergeRequestV1;
private shareDepositDetailsV1 = URLS.subBrokerShareDepositDetailsV1
private brokerageReqInsert = URLS.brokerageRequestInsertV1
private nfdcReport = URLS.nfdcRiskReport
private scriptExcel = URLS.scriptExcel
private investEdge = URLS.investEdge
private investcurrentTime = URLS.investcurrentTime
private optimum = URLS.optimum
private optimumMenu = URLS.optimumMenu
private easyRewards = URLS.easyRewards
private clientoremphierarchy = URLS.clientoremphierarchy
private BodHoldingEq = URLS.BodHolding
private BodHeaderEq = URLS.BodHeader
private FnoPositions = URLS.FnoPositions
private SlbmHoldings = URLS.SlbmHoldings
private clientSummary = URLS.clientSummary
private getPhysicalFNOReports = URLS.getPhysicalFNOReports
private editClientSummary = URLS.editClientSummary
private BranchMapping  = URLS.BranchMapping
private profileDetails = URLS.profileDetailsV1
private ClientProfileCapture = URLS.clientProfileCap
private clientOutstandingReport = URLS.clientOutstanding
private ClientProfileScore = URLS.clientRiskProfileScore
private hierarchyList = URLS.hierarchyList
private brokCurrentDetails = URLS.hybridBrokRequest
private brokCurrentDetailsV1 = URLS.hybridBrokRequestV1
private holdPhysicalFNOReports=URLS.holdPhysicalFNOReports;
private scripSummaryReport = URLS.scripSummaryReport
private brokerageInfo = URLS.brokerageInformation
private clientInteractionToken = URLS.clientInteractionToken;
private clientTicketDetailsUrl = URLS.clientTicketDetails;
private clientInteractionDetailsUrl = URLS.clientInteractionDetails;
private commoSummary = URLS.commSummaryList;
private tradingListRepo = URLS.tradingListRepo;
private commodityScripSum = URLS.commodityScripSum;
private vasDetailedReport = URLS.vasDetailedReport;
private RaaDebit   = URLS.RaaDebit
private mappedClient = URLS.mappedClient;
private demapClnt = URLS.demapClient;

private brokApprovalRej = URLS.brokApproRej
private productActDea = URLS.productActivationRights
private actDecProd = URLS.actDecProduct

private cmsDeposit = URLS.cmsDeposit;
private equityCms = URLS.equityCms;
private saveCmsEntry = URLS.saveCmsEntry;
private jvStatusOptions = URLS.jvStatusOption;
private getDPSchemeDetails=URLS.getDPSchemeDetails;
private ttMapping = URLS.ttMapping
private dpScriptReport = URLS.dpScript;
private getLivlongVal = URLS.getLivlong;
private getMarginShortfallVal = URLS.getMarginShortfall;
private clientMappingTableData = URLS.clientMappingTableData;
private getBeyongIRRVal = URLS.getBeyongIRR;
private freezeDetails = URLS.freezeDetails;
private dpModificationDetails = URLS.dpModificationDetails;
private searchScripDetails = URLS.searchScripDetails;
private clientDematHoldings = URLS.clientDematHoldings;
private SubmitEPIRequest = URLS.SubmitEPIRequest;
private clientMarginReport = URLS.clientMarginReport;
private accountClosureStatus = URLS.accountClosureStatus;
private settlementPayoutReport = URLS.settlementPayoutReport;
private dematRequestStatus = URLS.dematRequestStatus;
private downloadDematForm = URLS.reportDownload;
private aumExcelReportDownload = URLS.AumExcelReportDownload;
private disInwardDetail = URLS.disInwardDetail;
private onlineSIPExcelReportDownload = URLS.OnlineSIPExcelReportDownload;
private GetJVDetails = URLS.GetJVDetails;
private PendingPledgeRequests = URLS.PendingPledgeRequests;
private SubmitPledgeTransactionForRiskApproval = URLS.SubmitPledgeTransactionForRiskApproval;
private retentionMailerRequestStatus = URLS.retentionMailerRequestStatus;
private captureRetentionMailerRequest = URLS.captureRetentionMailerRequest;
private PartnerInfoReport = URLS.PartnerInfoReport;
private vendorAuthorize = URLS.vendorAuthorize;




public options: any ;

private globalCheckSumkey :any;
public tokenVal: any;
public paramsObj: any;
env:any;
cookieKEYclientInteractionToken:any
cookieKEYclientInteraction: any;
getLivlong: any;
private httpBackend: HttpClient; 
constructor(private httpClient: HttpClient,
	private nativeHttp: HTTP,
	private storage: StorageServiceAAA,
	private cipherText: CustomEncryption,
	private commonService: CommonService,private handler: HttpBackend) {
		this.httpBackend = new HttpClient(this.handler);
		
		this.storage.get('cookieValue').then(token => {
			this.tokenVal = token;
			let modifiedToken = this.tokenVal.split(";");
			let str = '';
			for(let i = 0 ; i < modifiedToken.length ; i++){
				if(modifiedToken[i].includes('ASP.NET_SessionId')){
					str = str + modifiedToken[i] + ';';
				}
				if(modifiedToken[i].includes('SameSite=Lax')){
					str = str + modifiedToken[i] + ';';
				}
				}
				this.tokenVal = str;
				this.tokenVal = this.tokenVal.replace(' SameSite=Lax','');
				this.tokenVal = this.tokenVal.replace('Path=/','');
		});
	}

	sendReqTOServer(params:any,config:any,reqHead:any): Observable<{}>{ 
			return this.httpClient.post('/api/secure/wire-service', {
				params,
				config,
				reqHead
			})
		}

	sendReqTOServer1(params:any,config:any,reqHead:any): Observable<{}>{ 
			return this.httpClient.post('/api/secure/common-all-service', {
				params,
				config,
				reqHead
			})
		}

	sendReqTOServerFormData(params:any,config:any,reqHead:any): Observable<{}>{
			let paramsToSend: any = params;
			if (params instanceof FormData) {
				paramsToSend = {};
				params.forEach((value: any, key: string) => {
					paramsToSend[key] = value;
				});
			}
			// For Android app use full URL (httpBackend resolves relative paths to localhost)
			// For web use relative path (works fine with interceptors)
			const url = this.commonService.isApp() 
				? environment.apiProxyBaseUrl + '/api/secure/wire-service-formdata'
				: '/api/secure/wire-service-formdata';
			
			return this.httpBackend.post(url, {
				params: paramsToSend,
				config,
				reqHead
			})
		}

    
    public getLimitReqStatus(cookievalue: any,caseId: any, passObj: any, userId: any): Observable<{}> {
		let params = {"body":{"CaseID":caseId,"CustomerID":"","EmployeeId":userId,"FromDate":passObj.fromDate,"Status":"","ToDate":passObj.toDate},
		"head":{"appname":this.limitReqStatus.appName,"appver":"1.0.26.0",
			"Authkey":"",
			"key":"",
			"osname":"Android","requestcode":"APIBO52UCVDWFY",
		"userType": this.commonService.get('userType')}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.limitReqStatus.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Authkey:"summaryReportKey",
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj);
		
	}

	public getClientMappingTableData(data: any, cookievalue: any): Observable<{}> {
		let params = {
			"body": data,
			"head": {
				"RequestCode": "APIBO52UCVDWFY",
				"Key": "",
				"AppVer": "01",
				"AppName": "AAA",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.clientMappingTableData.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj);

	}

	public getDpScrip(cookievalue: any, passObj: any, userId: any): Observable<{}> {
		let params = {"body":{"FromDate":passObj.fromDate,"PartnerCode":userId,"ToDate":passObj.toDate},"head":{"AppName":"AAA","AppVer":"01","Key":"","OsName":"Android","RequestCode":"CVUpdateLead01",
		"userType": this.commonService.get('userType')}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}

		const config = {
			url: this.dpScriptReport.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj);

	}


	public getjvReqStatus(cookievalue: any, passObj: any, userId: any): Observable<{}> {
		let params = {
			"body": {
				"FromDate": passObj.fromDate,
				"RMCode": userId,
				"Remark": "",
				"Status": passObj.Status,
				"ToDate": passObj.toDate
			}, "head":
			{
				"AppName": this.jvReqStatus.appName,
				"AppVer": "1.0.26.0",
				"Key": "",
				"OsName": "Android", "RequestCode": "CVUpdateLead01",
				"userType": this.commonService.get('userType')
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}

		if(this.commonService.isApp()){
			params.head.AppName = "AAA"
		}

		const config = {
			url: this.jvReqStatus.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj);
	}

	public getepiReqStatus(cookievalue: any, passObj: any, userId: any): Observable<{}> {
		let params = { 
			"head":{
				"AppName": "AAA",
				"AppVer": "1.0.4.0",
				"Key": "",
				"OsName": "Android",
				"RequestCode": "ProfileDetailsV1",
				"userType": this.commonService.get('userType') },
			"body":{
				"FromDate": passObj.fromDate,
				"Partnercode": userId,
				"ClientCode":passObj.clinetCode,
				"ToDate": passObj.toDate,
				"Status": passObj.Status
			}
		};

		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}

		const config = {
			url: this.epiReqStatus.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj);
	}

	public limitedValidator(cookievalue: any, pramsObj: any, userId: any): Observable<{}> {
		let params = {"body":{"EmployeeId":userId,"LoginID":pramsObj.clientID,"SegmentID":pramsObj.SegmentID},
		"head":{"AppName":this.limitValidate.appName,"AppVer":"1.0.26.0","Key":"","OsName":"Android","RequestCode":"CVUpdateLead01",
		"userType": this.commonService.get('userType')}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}		
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.limitValidate.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj);
	}

	public limitedInsert(cookievalue: any, parameter: any, caseId: any, userId: any): Observable<{}> {
		let params = {"body":{"ActualLimit":parameter.ActualLimit,"CaseID":caseId,"CustomerID":parameter.clientID,"EmployeeId":userId,"MarginRequirement":parameter.MarginRequirement,"ReqLimit":parameter.ReqLimit,"ReqRemark":parameter.ReqRemark,"SegmentID":parameter.SegmentID,"Status":"P"},"head":{"AppName":this.limitRequest.appName,"AppVer":"1.0.26.0","Key":"","OsName":"Android","RequestCode":"CVUpdateLead01",
		"userType": this.commonService.get('userType')}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};		
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.limitRequest.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj);

	}


	public getBrokerageApproval(cookievalue: any, userID: any): Observable<{}> {
		let params = {"body":{"PartnerCode":userID},"head":{"AppName":this.brokerageApproval.appName,"AppVer":"1.0.26.0","Key":"","OsName":"Android","RequestCode":"CVUpdateLead01",
		"userType": this.commonService.get('userType')}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.brokerageApproval.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj);

	}

	public getBrokerageRequest(cookievalue: any, paramsObj: any, userID: any): Observable<{}> {
		let checkSumKey = this.cipherText.generateCheckSumKey();
		let fromDate = paramsObj.fromDate;
		let toDate = paramsObj.ToDate;
		let status = paramsObj.status;
		let rmID = this.cipherText.createChecksum(userID ,checkSumKey);
		let clientID = "";	
		let srNO = 0;
		let stringValue = `${userID}_${fromDate}_${toDate}_${clientID}_${srNO}_${status}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;		
		const checkSumValue = this.cipherText.createChecksum(stringValue,this.globalCheckSumkey);
		

		let params = {
			"body":{
				"ClientCode":clientID,
				"FromDate":paramsObj.fromDate,
				"RMCode":rmID,
				"SrNo":srNO,
				"Status":paramsObj.status,
				"ToDate":paramsObj.ToDate},
				"head":{
					"AppName":this.brokergeRequestV1.appName,
					"AppVer":"1.0.26.0","Key":"",
					"OsName":"Android",
					"RequestCode":"CVUpdateLead01",
					"userType": this.commonService.get('userType'),
					"CheckSum": stringValue,
					"CheckSumKey":checkSumKey
					}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		
		if (cookievalue) {    
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.brokergeRequestV1.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
				CheckSum:true
			}
		} 
		return this.sendReqTOServer(params, config,obj);
	}

	public getShareDepositRecord(cookievalue: any, userID: any): Observable<{}> {
		let params = {"body":{"PartnerCode":userID},"head":{"appname":this.shareDepositDetailsV1.appName,"appver":"1.0.26.0",
			"Authkey":"","key":"","osname":"Android","requestcode":"APIBO52UCVDWFY",
		"userType": this.commonService.get('userType')}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.shareDepositDetailsV1.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Authkey:"summaryReportKey",
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}
	//brokerage insert get current data
	public getBrokerageCurrentData(cookievalue: any, clientId: any): Observable<{}> {
			let checkSumKey = this.cipherText.generateCheckSumKey();
			let stringValue = `${clientId}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
			const clientID = this.cipherText.createChecksum(clientId ,checkSumKey);

		let params = {
			"head": {
					"RequestCode": "HybridBrokerageRequest",
					"Key": "" ,
					"AppName": this.brokCurrentDetailsV1.appName,
					"AppVer": "01",
					"OsName": "Android",
					"userType": this.commonService.get('userType'),
					"CheckSum": stringValue,
					"CheckSumKey":checkSumKey
			},
			"body": {
				"ClientCode": clientID
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.brokCurrentDetailsV1.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
				CheckSum:true
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getBrokerageInsert(cookievalue: any, passObj: any, userId: any): Observable<{}> {
		const valuesToCompare = [
			passObj.niftyOptionPerLot,
			passObj.bankniftyOptionPerLot,
			passObj.finniftyOptionPerLot,
			passObj.midcpniftyOptionPerLot,
			passObj.niftynxt50OptionPerLot,
			passObj.sensexOptionPerLot,
			passObj.bankexOptionPerLot,
			passObj.sensex50OptionPerLot,
		  ];
		  
		  // Check if all values are the same
		  const allAreEqual = valuesToCompare.every(value => value === valuesToCompare[0]);
		  
		  // Set the IndexOptions value based on the check
		  const indexOptionsValue = allAreEqual ? valuesToCompare[0] : 0;
		let params = {
			"head": {
					"RequestCode": "ActiveDeactiveProduct",
					"Key": "",
					"AppName": this.brokerageReqInsert.appName,
					"AppVer": "01",
					"OsName": "Android",
					"userType": this.commonService.get('userType')
			},
			"body":{
				"CashDeliveryFirstSidePerc":passObj.cashDeliveryFirstSide,
				"CashDeliveryMinimumPerShare":passObj.cashDeliveryMps,
				"CashIntradayFirstSidePerc":passObj.cashIntradayFirstSide,
				"CashIntradayMinimumPerShare":passObj.cashIntradayMps,
				"CashIntradaySecondSidePerc":passObj.cashIntradaySecondSide,
				"CashT2TFirstSidePerc":passObj.cashT2TFirstSide,
				"CashT2TMinimumPerShare":passObj.cashT2TMps,
				"ClientCode":passObj.clientID,
				"FuturesDeliveryFirstSidePerc":passObj.futureDeliveryFirstSide,
				"FuturesDeliveryMinimumPerShare":passObj.futureDeliveryMps,
				"FuturesIntradayFirstSidePerc":passObj.futureIntradayFirstSide,
				"FuturesIntradayMinimumPerShare":passObj.futureIntradayMps,
				"FuturesIntradaySecondSidePerc":passObj.futureIntradaySecondSide,
				"hdnMTOF":"AAA",
				"OptionsIndexPerc":passObj.optionIndex,
				"OptionsPerLot":passObj.optionPerLot,
				"RMCode":userId,
				"Remark":"AAA",
				"RequestType":this.commonService.get('brokTypeParams'),
				"CashOrdFlag":passObj.CashOrdFlag,
				"FaoOrdFlag":passObj.FaoOrdFlag,
				"BrkOrdwise":passObj.BrkOrdwise,
				"IndexOptions": indexOptionsValue,
				"NIFTY": passObj.niftyOptionPerLot,
				"BANKNIFTY": passObj.bankniftyOptionPerLot,
				"FINNIFTY": passObj.finniftyOptionPerLot,
				"MIDCPNIFTY":passObj.midcpniftyOptionPerLot,
				"NIFTYNXT50": passObj.niftynxt50OptionPerLot,
				"SENSEX": passObj.sensexOptionPerLot,
				"BANKEX": passObj.bankexOptionPerLot,
				"SENSEX50": passObj.sensex50OptionPerLot,
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.brokerageReqInsert.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getNfdcReport(cookievalue: any, passObj: any,userId: any): Observable<{}> {
		let params = {"body":{"ClientCode":"","Email":passObj.Email,"RMCode":this.commonService.get('userId1'),"ReportType":passObj.reportType},"head":{"requestCode":passObj.requestCode,"key":"","appVer":"1.0.26.0","appName":this.nfdcReport.appName,"LoginId":passObj.encrpLogInId,
		"userType": this.commonService.get('userType')}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.nfdcReport.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getBodHoling(cookievalue: any, clientID: any, userID: any): Observable<{}> {
		let params = {"head": {"RequestCode": "BODHOLDING","Key": "","AppName": this.BodHoldingEq.appName,"AppVer": "1.0.4.0","OsName":"Android",
		"userType": this.commonService.get('userType')},"body": {"PartnerCode": userID,"ClientCode": clientID}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.nfdcReport.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getFnoPositions(cookievalue: any, clientID: any, userID: any): Observable<{}> {
		let params = {"head": {"RequestCode": "FNOPositions","Key": "","AppName": this.FnoPositions.appName,"AppVer": "1.0.4.0","OsName":"Android",
		"userType": this.commonService.get('userType')},"body": {"PartnerCode": userID,"ClientCode": clientID}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.FnoPositions.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getHoldingDetails(cookievalue: any, clientID: any, userID: any, holdingType: any): Observable<{}> {
		let params = {"head": {"RequestCode": "CVUpdateLead01","Key": "","AppName": "AAA","AppVer": "01","OsName":"Android",
		"userType": this.commonService.get('userType')},"body": {"PartnerCode": userID,"ClientCode": clientID,"HoldingType": holdingType}}
		let obj: any = {
			'appID': this.commonService.get('appID') || '',
			'Ocp-Apim-Subscription-Key' : ""
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.BodHoldingEq.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getHeaderDetails(cookievalue: any, clientID: any): Observable<{}> {
		let params = {"head": {"RequestCode": "CVUpdateLead01","Key": "","AppName": "AAA","AppVer": "01","OsName":"Android",
		"userType": this.commonService.get('userType')},"body": {"ClientCode": clientID}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
				const config = {
			url: this.BodHeaderEq.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getSlbmHoldings(cookievalue: any, clientID: any, userId: any): Observable<{}> {
		let params = {"head": {"RequestCode": "SLBMHoldings","Key": "","AppName": this.SlbmHoldings.appName,"AppVer": "1.0.4.0","OsName": "Android",
		"userType": this.commonService.get('userType')},"body": {"PartnerCode": userId,"ClientCode": clientID}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
				const config = {
			url: this.SlbmHoldings.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getClientSummary(cookievalue: any, branchId: any, SearchBy?: any, SearchText?: any, PageNo?: any,SortBy?: any,SortOrder?: any): Observable<{}> {
		let params = {"head": {"RequestCode": "CVUpdateLead01","Key": "",
			"AppName": this.SlbmHoldings.appName,"AppVer": "01","OsName": "Android",
		"userType": this.commonService.get('userType')},
		"body": {"PartnerCode": this.commonService.get('userId1'),
			"Category": "All", "Branch": branchId?branchId:"ALL", "PageNo": PageNo,
        "SortBy": SortBy?SortBy:"","SortOrder": SortOrder?SortOrder:"",
		"SearchBy": SearchBy?SearchBy:"","SearchText": SearchText?SearchText:""
		}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
			const config = {
			url: this.clientSummary.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public editSummary(cookievalue: any, passObj: any): Observable<{}> {
		let params = {"head": { "RequestCode": "DashboardDetail", "Key": "", "AppName": this.editClientSummary.appName,"AppVer": "1.0.4.0", "OsName": "Android",
		"userType": this.commonService.get('userType')}, 
		"body": {"LoginId": passObj.LoginId,"HoldBlockSell": passObj.HoldBlockSell ,
			 "BranchRemarkID":passObj.BranchRemarkID, "MakerId": "C122883"}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
			const config = {
			url: this.editClientSummary.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getBranch(cookievalue: any, userId: any): Observable<{}> {
		let params = {"body": {"RmCode": userId},"head": {"RequestCode": "CVUpdateLead01","Key": "","AppName": this.BranchMapping.appName,"AppVer": "01","OsName": "Android",
		"userType": this.commonService.get('userType')}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
			const config = {
			url: this.BranchMapping.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getHierarchyList(cookievalue: any, clientID: any): Observable<{}> {
		let params = {
			head: {
				RequestCode: "CVUpdateLead01",
				Key: "",
				AppName: this.hierarchyList.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
			},
			body: {
				Loginid: clientID
			}
		}
		let obj: any = {
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
					const config = {
			url: this.hierarchyList.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getProfileDetails(cookievalue: any, passObj: any, env:any): Observable<{}> {
		// if(this.env == undefined || this.env == null){
        //     this.env = env
		// 	this.gatewaySubscriptionKey = this.env.gatewaySubscriptionKey
		// 	this.globalCheckSumkey = this.env.generalChecksumKey.globalChecksumKey;
        // }
		passObj.RequestorCode = passObj.RequestorCode ? passObj.RequestorCode :  this.commonService.get('userId1') ? this.commonService.get('userId1') : "";
        passObj.ClientType = passObj.ClientType ? passObj.ClientType : "";

		let checkSumKey = this.cipherText.generateCheckSumKey();
		let stringValue = `${passObj.UserCode}_${passObj.UserType}_${passObj.RequestorCode}_${passObj.ClientType}_${this.profileDetails.appName}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
		const requestorCode = this.cipherText.createChecksum(passObj.RequestorCode ,checkSumKey);
		const userCode = this.cipherText.createChecksum(passObj.UserCode ,checkSumKey);

		let params = {
		head: {
			RequestCode: 'CVUpdateLead01',
			Key: "",
			AppName: this.profileDetails.appName,
			appVer: '01',
			OsName: 'Android',
			CheckSum: stringValue,
			CheckSumKey: checkSumKey
			},
		body: {
			"UserCode": userCode,
			"UserType": passObj.UserType,
			"RequestorCode": requestorCode,
			"ClientType": passObj.ClientType
			} 
		};
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
					const config = {
			url: this.profileDetails.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
				CheckSum:true
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}


	public getclientDematHoldings(cookievalue: any, clientId: any, dematID: any, ISIN: any): Observable<{}> {
		let params = { 
			"head": { 
				"RequestCode": "CVUpdateLead01",
				 "Key": "",
				  "AppName": "AAA",
				   "AppVer": "01", 
				   "OsName": "Android",
				   "userType": this.commonService.get('userType')
				},
			"body": {
				"Clientcode": clientId,
				"DematID": dematID,
				"ISIN": ISIN
			} 
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
					const config = {
			url: this.clientDematHoldings.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public submitEPIRequest(cookievalue: any, clientId: any, dematID: any, ISIN: any, symbol: any, qty: any): Observable<{}> {
		let params = { 
			"head": { 
				"RequestCode": "ProfileDetailsV1",
				 "Key":"",
				  "AppName": "AAA",
				   "AppVer": "1.0.4.0", 
				   "OsName": "Android",
				   "userType": this.commonService.get('userType') 
				},
			"body": {
				"ParentCode": this.commonService.get('userId1'),
				"ChildCode": clientId,
				"DematId": dematID,
				"ISIN": ISIN,
				"Symbol": symbol,
				"Qty": qty
			} 
			}
		
		let obj: any = {
		'Ocp-Apim-Subscription-Key' : "",
		'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.SubmitEPIRequest.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public getProfileCap(cookievalue: any,userID: any,clientId: any): Observable<{}> {
		let params =  {
			"head": {
			"RequestCode": "clientProfileCap",
			"Key": "",
			"AppName": "AAA",
			"AppVer": "01",
			"OsName": "Android",
			"userType": this.commonService.get('userType')},
			"body":{
				"loginid": userID,
				  "clientcode": clientId
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.ClientProfileCapture.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}
	public getOutstandingReport(cookievalue: any,fromDate: any,hierarchyListVar: any,N: any,U: any): Observable<{}> {
		let params =  {
			"head": {
			"RequestCode": "APIBO52UCVDWFY",
			"Key": "",
			"AppName": "AAA",
			"AppVer": "01",
			"OsName": "Android",
			"userType": this.commonService.get('userType')},
			"body":{
				"LoginId": this.commonService.get('userId1'),
				"Branch": hierarchyListVar,
				"AsOnDate": fromDate,
				"Exchange": N,
				"ExchangeType": U
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.clientOutstandingReport.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)

	}
		
	public getProfileScore(cookievalue: any,userID: any,clientId: any,riskScore: any,riskCategory: any,aumCategory: any): Observable<{}> {
		let params =  {
			
			"body":{
				"LoginId": userID,
				"ClientId": clientId,
				"RiskScore":riskScore,
				"RiskCategory":riskCategory,
				"AUMCategory" : aumCategory
			},
			"head": {
				"RequestCode": "APIBO52UCVDWFY",
				"Key": "",
				"AppVer": "01",
				"AppName": "AAA",
				"OsName": "Android",
				"userType": this.commonService.get('userType')}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.ClientProfileScore.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}
	
	public getBrokerageInfo(cookievalue: any, clientId: any): Observable<{}> {
		let params =  {"head": {"RequestCode": "CVUpdateLead01","Key":"","AppName": this.brokerageInfo.appName,"AppVer": "1.0.4.0","OsName": "Android",
		"userType": this.commonService.get('userType')},"body": {"ClientCode": clientId,"Segment": "ALL"}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.brokerageInfo.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}


	public getRaaDebitReport(cookievalue: any, reportType: any, userID: any) {
		let params =  {"head": {"requestCode": "RAADebitReport","key": "","appVer": "2.0","appName": this.RaaDebit.appName,"LoginId": reportType.encrpLogInId,
		"userType": this.commonService.get('userType')},"body": {"RMCode": this.commonService.get('userId1'),"ReportType":reportType.ReportType,"ClientCode":"","Email":"N"}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		}
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.RaaDebit.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)

	}

	public getBrokApprovalRej(cookievalue: any, brokObj: any,reqRa: any, userId: any) {
		let params = { 
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": this.brokApprovalRej.appName,
				"AppVer": "1.0.4.0",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
			"RMCode": userId,
				"ClientCode": brokObj.ClientCode,
				"Remark": brokObj.Remark,
				"SerialNo": brokObj.Srno,
				"Status": reqRa
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
				const config = {
			url: this.brokApprovalRej.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public submitProdActDec(cookievalue: any,passObj: any, userId: any) {
		let params = {
			"head": {
					"RequestCode": "ActiveDeactiveProduct",
					"Key": "",
					"AppName": this.actDecProd.appName,
					"AppVer": "01",
					"OsName": "Android",
					"userType": this.commonService.get('userType')
			},
			"body": {
				"PartnerCode": userId,
				"ProductName":passObj.productName,
				"Action": passObj.action,
				"ClientCode": passObj.clientID,
				"Remark": passObj.remark,
				"IsFileUpload":passObj.isupload,
				"FileData":passObj.fileData
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' :"",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
				const config = {
			url: this.actDecProd.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	//CMS Entry

	getCmsDepositBankList(cookievalue: any, user: any, typeNo: any){
		let params = {
		  "head":{
			 "RequestCode":"GetCMSClearingTypeV1",
			 "Key":"",
			 "AppName":this.cmsDeposit.appName,
			 "AppVer":"01",
			 "OsName":"Android",
			 "userType": this.commonService.get('userType')
		  },
		  "body":{
			 "UserCode":user,
			 "ProductType":"EQ",
			 "UserType":typeNo
		  }
	   }
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
				const config = {
			url: this.cmsDeposit.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	  }

	  getEquityCms(cookievalue: any, clientId: any, userId: any, userType: any){
		let params = {
			"head": {
			  "RequestCode": "GetCMSClearingTypeV1",
			  "Key": "",
			  "AppName": this.equityCms.appName,
			  "AppVer": "01",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			},
			"body": {
			  "ProductType": "EQ",
			  "ClientID": clientId,
			  "UserID": userId,
			  "UserType": userType == "RM" ? "1" : userType == "FAN" ? "2" : "3",
			}
		  }

		  let obj: any = {
		  	'Ocp-Apim-Subscription-Key' : "",
			  'appID': this.commonService.get('appID') || ''
		  };	
		  if (cookievalue) {
			obj['token'] = cookievalue;
		  }
		const config = {
			url: this.equityCms.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
		 
	  }

	  saveEquityCms(cookievalue: any, passObj: any){
		let params = {
			"head": {
			  "RequestCode": "SaveCMSEntryV1",
			  "Key": "",
			  "AppName": this.saveCmsEntry.appName,
			  "AppVer": "01",
			  "OsName": "Android",
			  "userType": this.commonService.get('userType')
			},
			"body": passObj
		  }

		  let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		  };
		
		  if (cookievalue) {
			obj['token'] = cookievalue;
		  }
		  const config = {
			url: this.saveCmsEntry.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)

		 
	  }

	  public editSummaryReport(cookievalue: any, HoldBlockSellandBranchRemarkIDList: any): Observable<{}> {
		let params = {"head": { "RequestCode": "CVUpdateLead01", "Key": "", "AppName": this.editClientSummary.appName,"AppVer": "01", "OsName": "Android",
		"userType": this.commonService.get('userType')}, "body": {"LoginId": this.commonService.get('userId1'),HoldBlockSellandBranchRemarkIDList}}
		let obj: any = {
			'appID': this.commonService.get('appID') || '',
			'Ocp-Apim-Subscription-Key' : ""
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.editClientSummary.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'VerifyRequestApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	//Done By Vaitheeswaran
	getallClientWireRequest(body: { PartnerCode: Promise<any>; ClientCode: string; },token: any, segment?: string) {
		let params={
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"PartnerCode": body.PartnerCode,
				"ClientCode": body.ClientCode,
				"SearchBy": body.ClientCode?body.ClientCode:"",
				"Segment": segment || 'EQ'
			}
		}
		let obj: any = {
			'appID': this.commonService.get('appID') || '',
			'Ocp-Apim-Subscription-Key' : ""
		};
		if (token) {
			obj['token'] = token;
		}
		const config = {
			url: this.getPhysicalFNOReports.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		}
		return this.sendReqTOServer(params, config,obj)
	}

	holdSelectedReports(groupList: any,token: any,userid: any, segment?: string) {

		let trimmedGroupList = (groupList || []).map((item: any) => ({
			...item,
			ClientCode: typeof item.ClientCode === 'string' ? item.ClientCode.trim() : item.ClientCode
		}));

		let params={

			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "446794970AAA1237ab394d176612f8c6",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android"
			},
			"body": {
				"PartnerCode": userid,
				"Segment": segment || 'EQ',
				"data":trimmedGroupList
			}
			}

		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (token) {
			obj['token'] = token;
		}
		const config = {
			url: this.holdPhysicalFNOReports.url,
			subKey:'AAA_OCP',
			bodyHead:{

			}
		}
		return this.sendReqTOServer(params, config,obj)
	}

	getallClientSearchWireRequest(body: { PartnerCode: any; ClientCode: any; }, tokendata: any) {
		let params={
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"PartnerCode": body.PartnerCode,
				"ClientCode": body.ClientCode,
				"SearchBy": body.ClientCode?body.ClientCode:""
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (tokendata) {
			obj['token'] = tokendata;
		}
		const config = {
			url: this.getPhysicalFNOReports.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
		} 
		return this.sendReqTOServer(params, config,obj)
		}

		getDPSchemeCharges(clientCode: any,Token: any,userID: any) {
			const checkSumKey = this.cipherText.generateCheckSumKey()
					const checkSumString = clientCode + "_" + userID + "_" + checkSumKey + "_" + moment(new Date()).format('DDMMYYYY')
					
					const ClientCode = this.cipherText.createChecksum(clientCode,checkSumKey)
					const RMCode = this.cipherText.createChecksum(userID,checkSumKey)
			let params= {
				"head": {
					"RequestCode": "CVUpdateLead01",
					"Key": "",
					"AppName": "AAA",
					"AppVer": "01",
					"OsName": "Android",
					"userType": this.commonService.get('userType'),
					"ChecksumKey":checkSumKey,
					"CheckSum":checkSumString
				},
				"body": {
				"PartnerCode": RMCode,
				"ClientCode": ClientCode
				}
			}
			let obj: any = {
				'Ocp-Apim-Subscription-Key' : "",
				'appID': this.commonService.get('appID') || ''
			};
			if (Token) {
				obj['token'] = Token;
			}
					const config = {
			url: this.getDPSchemeDetails.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
				CheckSum:true
			}
		} 
		return this.sendReqTOServer(params, config,obj)
		}
		
	public ttnowMapping(cookievalue: any, ttMappingData: any) {
		// let checkSumKey = this.cipherText.generateCheckSumKey()
		// let stringValue = ttMappingData[0].Clientcode+'_'+ttMappingData[0].DealerId+"_"+checkSumKey+"_"+moment(new Date()).format('DDMMYYYY');
		// for (let i = 0; i < ttMappingData.length; i++) {
		// 	ttMappingData[i].Clientcode = this.cipherText.createChecksum(ttMappingData[i].Clientcode, checkSumKey);
		// 	ttMappingData[i].DealerId = this.cipherText.createChecksum(ttMappingData[i].DealerId, checkSumKey);
		// }
		// let params = {
		// 	"head":
		// 	{
		// 		"RequestCode": "CVUpdateLead01",
		// 		"Key": "",
		// 		"AppName": "AAA",
		// 		"AppVer": "01",
		// 		"OsName": "Android",
		// 		"CheckSum": stringValue,
		// 		"CheckSumKey": checkSumKey,
		// 		"userType": this.commonService.get('userType')
		// 	}, "body":ttMappingData
		// }
		// let obj: any = {
		// 	'Ocp-Apim-Subscription-Key': "",
		// 	'appID': this.commonService.get('appID') || ''
		// };
		// if (cookievalue) {
		// 	obj['token'] = cookievalue;
		// }
		// const config = {
		// 	url: this.ttMapping.url,
		// 	subKey:'AAA_OCP',
		// 	bodyHead:{
		// 		Key: 'Verify_Guest_And_ExtendedApi',
		// 		checkSum:true
		// 	}
		// } 
	let url = this.ttMapping.url;
    let userType= this.commonService.get('userType') || '';
    let appId = this.commonService.get('appID') || '';
	return this.httpClient.post('/api/secure/tt-now-mapping',{
		cookievalue,userType,appId,ttMappingData,url
	})
	}

	public getClientInteractionToken(env?:any): Observable<{}> {
		
		let params: any = {};
		
		let obj = {
			'Authorization' : "cookieKEYclientInteractionToken",
			'userkey' : "UserKey",
			'Ocp-Apim-Subscription-Key' : "iiflcrm_OCP",
			'appID': this.commonService.get('appID') || ''
		};
		let	config={
				url: `${this.clientInteractionToken.url}`,
					subKey:'iiflcrm_OCP',
					Authorization:"cookieKEYclientInteractionToken",
				}
		return this.sendReqTOServer(params, config,obj)
	}

	public clientTicketDetails(cookievalue: any, ticketData: any): Observable<{}> {
		let params = {
			"Parameters": {
				"ClientCode": ticketData
			}
		};
		let obj = {
			'userkey' : "UserKey",
			'Ocp-Apim-Subscription-Key' : "",
			Authorization:'CRM-oauthtoken ' + cookievalue
		};
		const config = {
			url: this.clientTicketDetailsUrl.url,
			subKey:'iiflcrm_OCP',
			bodyHead:{
			}
		} 
		return this.sendReqTOServer(params, config,obj)
	}

	public clientInteractionDetails(cookievalue: any, ticketData: any): Observable<{}> {
		let params = {
			"Parameters": {
				"ClientCode": ticketData
			}
		};
			let obj = {
			'userkey' : "UserKey",
				'Ocp-Apim-Subscription-Key' : "",
				'Authorization':'CRM-oauthtoken ' + cookievalue
			};
			const config = {
			url: this.clientInteractionDetailsUrl.url,
			subKey:'iiflcrm_OCP',
			bodyHead:{
			}
		} 
		return this.sendReqTOServer(params, config,obj)
		}

		public scripMasterExcel(cookievalue: any, txt: any, filter: any): Observable<{}> {
			let params = {
				"body": {
					"login": this.commonService.get('userId1'),    
					"txt": txt,
					"Filter": filter
				},
				"head": {
					"RequestCode": "CVUpdateLead01",
					"Key": "",
					"AppName": "AAA",
					"AppVer": "01",
					"OsName": "Android",
					"userType": this.commonService.get('userType')
				}}
			let obj: any = {
				'Ocp-Apim-Subscription-Key' : "",
				'appID': this.commonService.get('appID') || ''
			}
			if (cookievalue) {
				obj['token'] = cookievalue;
			}
			const config = {
			url: this.scriptExcel.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
			} 
			return this.sendReqTOServer(params, config,obj)
		}

		getOptimumLink(authorization:any,userType: any, userCode: any,menuId: any,showMenu: any = '0'){

			let params = {
				'User_type': userType,
				'User_code': this.cipherText.aesEncrypt(userCode),
				'Page_Id': menuId,
				'Prm_1': '',
				'ShowHeaderMenuFooterMenu':showMenu?showMenu:'0'
			}
			
			let obj = {
				'Authorization': `Bearer ${authorization}`,
				'Content-Type': 'application/json',
				"Ocp-Apim-Subscription-Key": "",
				'appID': this.commonService.get('appID') || ''
			};
				const config = {
			url: this.optimum.url,
			subKey:'invest_OCP',
			bodyHead:{
			}
			} 
			return this.sendReqTOServer(params, config,obj)
		}

		getOptimumMenu(authorization:any,userCode: any,){
	let userID = { 
				 "userid": userCode 
				} 
				let userJson = JSON.stringify(userID);
				let userEncrypt =  this.cipherText.rijndaelEncrypt(userJson)
			
			let params = {
				'data':userEncrypt
			}
			

			let obj = {
				'Authorization': `Bearer ${authorization}`,
				'Content-Type': 'application/json',
				"Ocp-Apim-Subscription-Key": "",
				'appID': this.commonService.get('appID') || ''
			};
			const config = {
			url: this.optimumMenu.url,
			subKey:'invest_OCP', 
			bodyHead:{
			}
			} 
			return this.sendReqTOServer(params, config,obj)
		}

		getClientoremphierarchy(authorization:any,userCode: any,){
			let params = {
				'clientCode': this.cipherText.aesEncrypt(userCode),
				}
			
			let obj = {                                
				'Authorization': `Bearer ${authorization}`,
				'Content-Type': 'application/json',
				"Ocp-Apim-Subscription-Key": "",
			};
			const config = {
			url: this.clientoremphierarchy.url,
			subKey:'AAA_OCP',
			bodyHead:{
			}
			} 
			return this.sendReqTOServer(params, config,obj)
		}


		getinvestEdge(authorization:any){

			let formData = new FormData();
			formData.append('username', this.commonService.get('userId1') ?? '');
			formData.append('iifl_token', this.cipherText.aesEncrypt(this.commonService.get('jwt_token')));
			formData.append('iifl_cookie', this.cipherText.aesEncrypt(this.commonService.get('brokerageToken')));

			let obj = {
				'Authorization': `Bearer ${authorization}`,
				"Ocp-Apim-Subscription-Key": "investEdge2_OCP",
				'DeleteContentType': 'Yes',
				'appID': this.commonService.get('appID') || '',
			};
			const config = {
			url: this.getBeyongIRRVal.url,
			subKey:'investEdge2_OCP',
			bodyHead:{
			}
			} 
			return this.sendReqTOServerFormData(formData, config,obj)
		
		}

		getinvestcurrentTime() {
			let obj: any = {
				'Ocp-Apim-Subscription-Key' : "investEdge2_OCP"
			}
			const config = {
			url: this.investcurrentTime.url,
			subKey:'investEdge2_OCP',
			bodyHead:{
			}
			} 
			return this.sendReqTOServerGet({}, config,obj)
		}

		getRealTimeMarginShortfall(Token:any, userID:any,isNegativeMargin?:any) {
			this.paramsObj = {
				"head": {
					"RequestCode": "CVUpdateLead01",
					"Key": "",
					"AppName": "AAA",
					"AppVer": "01",
					"OsName": "Android",
					"userType": this.commonService.get('userType')
				},
				"body": {
					"PartnerCode": userID,
					"PageNo": "0",
					"SortBy": "",
					"SortOrder": "asc",
					"SearchBy": "",
					"SearchText": ""
				}
			}
			if (isNegativeMargin) {
				this.paramsObj.body['Type'] = "N"
			}
			const params = this.paramsObj;
			let obj: any = {
				'Ocp-Apim-Subscription-Key' : "",
				'appID': this.commonService.get('appID') || ''
			};
			if (Token) {
				obj['token'] = Token;
			}
			const config = {
			url: this.getMarginShortfallVal.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
			} 
			return this.sendReqTOServer(params, config,obj)

		}

		getLivLong(cookievalue: any,details: any){
			
			let params = { 
				"apiKey": "", 
				"userName": this.commonService.get('userId1'), 
				"requestData" : [
					{"Key" : "Name", "Value" : details.Name },			
					{"Key" : "Email", "Value" : details.Email },
					{"Key" : "MobileNo", "Value" : details.MobileNo},
				] 
			}
			  let obj: any = {
				'appID': this.commonService.get('appID') || ''
			};
			const config = {
			url: this.getLivlongVal.url,
			subKey:'AAA_OCP',
			bodyHead:{
				apiKey: 'getLivlong',
			}
			} 
			return this.sendReqTOServer(params, config,obj)
			 
		  }
		  
	public getScripSummaryReport(cookievalue: any,id: any,symbol: any): Observable<{}> {
		let params = {
			"head": {
			"RequestCode": "APIBO52UCVDWFY",
			"Key": "",
			"AppName": "AAA",
			"AppVer": "01",
			"OsName": "Android",
			"userType": this.commonService.get('userType')
			}, 
			"body": {
				"loginid": id,
				"Symbol": symbol
			}
		};
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.scripSummaryReport.url,
			subKey:'AAA_OCP',
			bodyHead:{
				Key: 'Verify_Guest_And_ExtendedApi',
			}
			} 
			return this.sendReqTOServer(params, config,obj)
	}		  

	public commoditySummaryList(cookievalue: any, data: any): Observable<{}> {
		let params = {
			"body": data,
			"head": {
				"RequestCode": "APIBO52UCVDWFY",
				"Key": "",
				"AppVer": "01",
				"AppName": 'AAA',
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			}
		}
		let obj: any = {
			'appID': this.commonService.get('appID') || '',
			'Ocp-Apim-Subscription-Key' : ""
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.commoSummary.url,
			subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public getConsolidatedTradingReport(cookievalue: any, segment: any, date: any, symbolName?: any, pageNo?: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppVer": "01",
				"AppName": 'AAA',
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"LoginId": this.commonService.get('userId1'),
				"segment": segment,
				"asondate": date,
				"Scripcode": symbolName ? symbolName : "",
				"PageNo": pageNo ?? 1
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
			url: this.tradingListRepo.url,
			subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}
	public getCommodityClientScripSummary(cookievalue: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppVer": "1.0.4.0",
				"AppName": 'AAA',
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"loginid": this.commonService.get('userId1')
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
				const config = {
			url: this.commodityScripSum.url,
			subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public getVasDetailedReport(cookievalue: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "ProfileDetailsV1",
				"Key": "",
				"AppVer": "1.0.4.0",
				"AppName": 'AAA',
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"loginid": this.commonService.get('userId1'),
				"ClientCode": ""
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
			const config = {
				url: this.vasDetailedReport.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}
	
	public getFreezeDetails = (cookieValue: any, freezeReason: any, loginId: any): Observable<{}> => {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": this.freezeDetails.appName,
				"AppVer": "1.0.4.0",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body":{
				"loginid": loginId,
				"srchby": "",
				"sortby": "",
				"sortorder": "",
				"freezereason": freezeReason,
				"pagenumber": "0"
			}
		}

		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if(cookieValue){
			obj['token'] = cookieValue;
		}
			const config = {
				url: this.freezeDetails.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				}
			} 
			return this.sendReqTOServer(params, config,obj)
	} 

	public getDpModificationReport = (cookieValue: any, loginId: any, dpType: any, fromDate: any, toDate: any) : Observable<{}> => {
		let params = {
			"head": {
				"RequestCode": "ProfileDetailsV1",
				"Key": "",
				"AppName": this.dpModificationDetails.appName,
				"AppVer": "1.0.4.0",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"LoginId": loginId,
				"ClientCode": "",
				"DPType": dpType,
				"FromDate": fromDate,
				"ToDate": toDate
			}
		}

		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if(cookieValue){
			obj['token'] = cookieValue;
		}
		const config = {
				url: this.dpModificationDetails.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public getSettlementPayoutReport = (cookieValue: any, loginId: any): Observable<{}> => {
    	let checkSumKey = this.cipherText.generateCheckSumKey();
		let stringValue = `${loginId}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
		const loginID = this.cipherText.createChecksum(loginId ,checkSumKey);
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppVer": "01",
				"AppName": this.settlementPayoutReport.appName,
				"OsName": "Android",
				"CheckSum": stringValue,
				"CheckSumKey":checkSumKey
			},
			"body": {
				"LoginID": loginID
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookieValue) {
			obj['token'] = cookieValue;
		}
				const config = {
				url: this.settlementPayoutReport.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				CheckSum:true

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public getDematRequestStatus = (cookieValue: any, loginId: any, pageNo: number, dpType: string, searchtxt? : any): Observable<{}> => {
		let params = {
			"head": {
				"RequestCode": "ProfileDetailsV1",
				"Key": "",
				"AppName": this.dematRequestStatus.appName,
				"AppVer": "1.0.4.0",
				"OsName": "Android"
			},
			"body": {
				"Partnercode": loginId,
				"PageNo": pageNo ,
				"Fliter": dpType,
				"SearchBy": searchtxt ? "ClientCode" : "",
				"SearchText": searchtxt ? searchtxt : ""
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookieValue) {
			obj['Token'] = cookieValue;
		}
		const config = {
				url: this.dematRequestStatus.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'dematRequestStatus',

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public getSearchScripDetails = (cookieValue: any,searchText: any, segment?: any) : Observable<{}> => {
		let params = {
			"head": {
				"RequestCode": "ProfileDetailsV1",
				"Key": "",
				"AppName": this.searchScripDetails.appName,
				"AppVer": "1.0.4.0",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"SrchTxt": searchText,
				"Segment": segment ? segment : ""
			}
		}

		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if(cookieValue){
			obj['token'] = cookieValue;
		}
		const config = {
				url: this.searchScripDetails.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public getAccountClosureStatus = (cookieValue: any, loginId: any, fromDate: any, toDate: any) : Observable<{}> => {
		let params = {
			"head": {
				"RequestCode": "ProfileDetailsV1",
				"Key": "",
				"AppName": this.accountClosureStatus.appName,
				"AppVer": "1.0.4.0",
				"OsName": "Android",
				"userType": this.commonService.get('userType')
			},
			"body": {
				"FromDate": fromDate,
				"ToDate": toDate,
				"PartnerCode": loginId,
				"ChildCode": "",
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if(cookieValue){
			obj['token'] = cookieValue;
		}
		const config = {
				url: this.accountClosureStatus.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}
	
	public getMappedClients(clientId: any, cookievalue: any): Observable<{}> {
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppName": "AAA",
				"AppVer": "01",
				"OsName": "Android"
			},
			"body": {
				"ClientCode": clientId
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if(cookievalue){
			obj['token'] = cookievalue;
		}
				const config = {
				url: this.mappedClient.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}
	public demapClient(dataToSend: any, token: any) {
		let params: any = {
			"head": {
				"RequestCode": "APIBO52UCVDWFY",
				"Key": "",
				"AppVer": "01",
				"AppName": "AAA",
				"OsName": "Android"
			},
			"body": dataToSend
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' :"",
			'appID': this.commonService.get('appID') || ''
		};
		if (token) {
			obj['token'] = token;
		}
						const config = {
				url: this.demapClnt.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public getDownloadDematForm = (cookieValue: any, dpType: any, downloadCount: any, loginId: any): Observable<{}> => {
		let params: any = {
			"rptId": dpType == 'CDSL' ? "497" : "498",
				"Type": dpType,
				"ClientCode": loginId,
				"downloadCount": downloadCount,
				"SendEmail": "N",
				"ReportFormat": "PDF",
				"CallFrom": "AAA"
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "AAA_OCP",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookieValue) {
			obj['token'] = cookieValue;
		}
		const config = {
				url: this.downloadDematForm.url,
				subKey:'AAA_OCP',
				bodyHead:{
					// apiKey: 'Verify_Guest_And_ExtendedApi',

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public scriptExcelAumReport(data : any){
		const params : any = 
		{
			"head":
			{
				"RequestCode": data.RequestCode,
				"Key": "",

				"AppName": "AAA",
				"AppVer": data.AppVer,
				"OsName": data.OsName
			},
			"body":
			{
				"LoginID": data.loginId,
				"FromDate": data.fromDate,
		    	"ToDate": data.toDate,	
			}	
		}
		if (data.RequestCode == "FetchClientDashBoardDetails" ) {
			params.body.PartnerCode = data.PartnerCode;
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "AAA_OCP",
			'appID': this.commonService.get('appID') || ''
		}
		const usersType = data.loginId[0] === 'C' ? '1' : '2';
		if (data.token) obj['token'] = data.token;
		
		if(data.RequestCode == 'GetOnlineSIPReport'){
			const config = {
				url:this.onlineSIPExcelReportDownload.url,
				// `${this.onlineSIPExcelReportDownload.url}?User_Id=${data.loginId}&User_Type=${usersType}&FromDate=${data.fromDate}&ToDate=${data.toDate}`,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',

				}
			} 
			return this.sendReqTOServer(params, config,obj)
		} else {
			const config = {
				url: this.aumExcelReportDownload.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',

				}
			} 
			return this.sendReqTOServer(params, config,obj)
		}

	}

	public getDisInwardDetails = (cookieValue: any, userId: any, dpType: any, fromDate: any, toDate: any) : Observable<{}> => {
		let params = {
			"head": {
				"RequestCode": "ProfileDetailsV1",
				"Key": "",
				"AppName": this.disInwardDetail.appName,
				"AppVer": "1.0.4.0",
				"OsName": "Android"
			},
			"body": {
				"PartnerCode": userId,
				"ChildCode": "",
				"DPType": dpType,
				"FromDate": fromDate,
				"ToDate": toDate
			}
		}

		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if(cookieValue){
			obj['token'] = cookieValue;
		}
		const config = {
				url: this.disInwardDetail.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public getJVReqReason = (RequestType: any, ClientCode: any, token: any): Observable<{}> => {
		let checkSumKey = this.cipherText.generateCheckSumKey()
		let stringValue
		if (RequestType.api == 'GetJVDetails') {
			stringValue = `${this.commonService.get('userId1')}_${ClientCode}_${RequestType.JvReason}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
		} else {
			stringValue = `${this.commonService.get('userId1')}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
		}
		const patnerCode = this.cipherText.createChecksum(ClientCode, checkSumKey);
		const loginID = this.cipherText.createChecksum(this.commonService.get('userId1'), checkSumKey);
		let params = {
			"head": {
				"RequestCode": RequestType.requestCode,
				"Key": "",
				"AppName": this.GetJVDetails.AppName,
				"AppVer": this.GetJVDetails.AppVer,
				"OsName": this.GetJVDetails.OsName,
				"CheckSum": stringValue,
				"CheckSumKey": checkSumKey
			},
			"body": {} as ParamsBody  // Assert body type to ParamsBody
		};

		if (RequestType.api == 'GetJVReversalReasonDepartment') {
			params.body.LoginId = loginID
		}
		else if (RequestType.api == 'GetJVDetails') {

			params.body.LoginId = loginID,
				params.body.Reason = RequestType.JvReason
			params.body.ClientCode = patnerCode

		} else if (RequestType.api == 'GetJVReversalStatus') {
			params.body.LoginID = loginID,
				params.body.SearchBy = RequestType.ReversalStatusData.Status !== '' ? 'status' : "",
				params.body.Searchtext = RequestType.ReversalStatusData.Status,
				params.body.FromDate = RequestType.ReversalStatusData.fromDate,
				params.body.ToDate = RequestType.ReversalStatusData.toDate
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': "",
			'appID': this.commonService.get('appID') || ''
		};
		if (token) {
			obj['token'] = token;
		}
		const config = {
				url: `${this.GetJVDetails.url}${RequestType.api}`,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
					CheckSum:true
				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public jvInsterDetails(cookievalue: any, jvDetails: any, jvRequest: any, ClientCode: any): any {
		let checkSumKey = this.cipherText.generateCheckSumKey();
		let stringValue = `${this.commonService.get('userId1')}_${ClientCode}_${jvRequest.jvReason}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;

		const patnerCode = this.cipherText.createChecksum(ClientCode, checkSumKey);
		const loginID = this.cipherText.createChecksum(this.commonService.get('userId1'), checkSumKey);
		let array: any = [];
		const createJVObject = (res : any) => ({
			"ClientCode": patnerCode,
			"DocumentOrInvoiceNo": res.DocumentOrInvoiceNo || "",
			"Remark": res.Remark,
			"Date": res.Date ? res.Date.trim() : "",
			"Amount": res.Amount || "",
			"JVAmount": res.JVAmount || "",
			"Balance": res.Balance || "",
			"Reason": jvRequest.jvReason,
			"Department": jvRequest.jvDepartment || "",
			"ReversalAvailed": res.ReversalAvailed || "",
			"LoginID": loginID
		})

		if (jvRequest.jvReason == 'Dealing Error') {
			array.push(createJVObject({
				Remark: jvRequest.Remark,
				JVAmount: jvRequest.jvReversalAmount,
				Department: jvRequest.jvDepartment,
			}));
		} else {
			jvDetails.map((res: any) => {
				array.push(createJVObject(res));
			})
		}
		let params = {
			"head": {
				"RequestCode": "GetJVReversalReasonDepartment",
				"Key": "",
				"AppName": this.jvInsert.AppName,
				"AppVer": this.jvInsert.AppVer,
				"OsName": this.jvInsert.OsName,
				"CheckSum": stringValue,
				"CheckSumKey": checkSumKey
			},
			"body": array
		}

		let obj: any = {
			'Ocp-Apim-Subscription-Key': "",
			'appID': this.commonService.get('appID') || ''
		}

		if (cookievalue) {
			obj['token'] = cookievalue;
		}

		const config = {
				url: this.jvInsert.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
					CheckSum:true
				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	jvApproveRejectStatus(cookievalue: any, passObj: any) {
		let checkSumKey = this.cipherText.generateCheckSumKey();
		let stringValue = `${this.commonService.get('userId1')}_${passObj.ClientCode}_${passObj.Reason}_${passObj.UserLevel}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
		const patnerCode = this.cipherText.createChecksum(passObj.ClientCode, checkSumKey);
		const loginID = this.cipherText.createChecksum(this.commonService.get('userId1'), checkSumKey);

		let params = {
			"head": {
				"RequestCode": "ApproveRejectJVRequest",
				"Key": "",
				"AppName": this.jvStatusOptions.AppName,
				"AppVer": this.jvStatusOptions.AppVer,
				"OsName": this.jvStatusOptions.OsName,
				"CheckSum": stringValue,
				"CheckSumKey": checkSumKey
			},
			"body": passObj
		}
		params.body.ClientCode = patnerCode;
		params.body.loginID = loginID;

		let obj: any = {
			'Ocp-Apim-Subscription-Key': "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			obj['token'] = cookievalue;
		}
		const config = {
				url: this.jvStatusOptions.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
					CheckSum:true
				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}


public getRevenueCalculator(body: any,token:any): Observable<{}> {
  // Head object
  const head = {
    RequestCode: "REQ123",
    Key: "SomeKey",
    AppVer: "1.0",
    AppName: "BackOfficeApp",
    OsName: "Windows",
    CheckSum: "",
    CheckSumKey: ""
  };
		let params = {body, head }

	const config = {
				url: this.revenueCalculator.url,
				subKey:'AAA_OCP',
				token:token,
				customKey:"getRevenueCalculator"
			} 

		return this.httpClient.post('/api/secure/wire-service-custom', {config,params,token})
	}
public getRevenueAssumptions(token:any): Observable<{}> {
		let params = {}
		let obj: any = {
			'Ocp-Apim-Subscription-Key': "AAA_OCP",
			 'token' : token
		};
		const config = {
				url: this.revenueAssumptions.url,
				subKey:'AAA_OCP',
				bodyHead:{
				}
			} 
			return this.sendReqTOServerGet(params, config,obj)

}

public getSaveRevenueSimulationTracker(body: any, token:any): Observable<any> {
	// Head object
  const head = {
	RequestCode: "CVUpdateLead01",
	Key: "",
	AppName: "AAA",
	AppVer: "1.0.4.0",
	OsName: "Android",
    CheckSum: "",
    CheckSumKey: ""
  };
  // Compute checksum
//   const dateStr = new Date().toLocaleDateString('en-GB').replace(/\//g, ''); // ddMMyyyy
//   const checksumString =
//     body.Loginid + "_" + body.savedate + "_" + body.Year + "_" + body.YoY + "_" + body.MFSIPAmt + "_" + body.MFSIPCount +
//     "_" + body.MFLumpsumAmt + "_" + body.MFLumpsumCount + "_" + body.FDAmt + "_" + body.FDCount +
//     "_" + body.NCDAmt + "_" + body.NCDCount + "_" + body.LifeInsuranceAmt + "_" + body.LifeInsuranceCount +
//     "_" + body.HealthInsuranceAmt + "_" + body.HealthInsuranceCount + "_" + body.PMSAmt + "_" + body.PMSCount +
//     "_" + body.AIFAmt + "_" + body.AIFCount +
//     "_" + head.CheckSumKey + "_" + dateStr;
// 		head.CheckSum = this.cipherText.createChecksum(checksumString,this.globalCheckSumkey).toString();
		let params = {body, head }

		const config = {
				url: this.saveRevenueSimulation.url,
				subKey:'AAA_OCP',
					Key: 'Verify_Guest_And_ExtendedApi',
					CheckSum:true,
					customKey:"getRevenueCalculator"
			} 
			return this.httpClient.post('/api/secure/wire-service-custom', {config,params,token})

}

public getfetchRevenueTracker( userID:any, partnerID:any, token:any): Observable<any> {

		let params = {
			"body":{
				"LoginID":userID,
				"PartnerCode":partnerID,
			
			},
				"head":{
						RequestCode: "CVUpdateLead01",
						Key: "",
						AppName: "AAA",
						AppVer: "1.0.4.0",
						OsName: "Android",
						"CheckSum": "",
						"CheckSumKey": ""
					}}
		
			const config = {
				url: this.fetchRevenueTracker.url,
				subKey:'AAA_OCP',
					Key: 'Verify_Guest_And_ExtendedApi',
					CheckSum:true,
					customKey:"getRevenueCalculator",
					encrypt:["LoginID",
				"PartnerCode"]
			} 
			return this.httpClient.post('/api/secure/wire-service-custom', {config,params,token})

}

public getRevenueTrackerDetail(userID:any, partnerID:any, token:any, trackerId:any): Observable<any> {
		let params = {
			"body":{
				"LoginID":userID,
				"PartnerCode":partnerID,
				"TrackerId":trackerId.toString()
			},
				"head":{
						RequestCode: "CVUpdateLead01",
						Key: "",
						AppName: "AAA",
						AppVer: "1.0.4.0",
						OsName: "Android",
						"CheckSum": "",
						"CheckSumKey": ""
					}}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : '',
			 'token' : token
		}
		const config = {
				url: this.RevenueTrackerDetail.url,
				subKey:'AAA_OCP',
					Key: 'Verify_Guest_And_ExtendedApi',
					CheckSum:true,
					customKey:"getRevenueCalculator",
					encrypt:["LoginID",
				"PartnerCode",
				"TrackerId"]
			} 
			return this.httpClient.post('/api/secure/wire-service-custom', {config,params,token})
}

getEasyReward(){
		let params = {
				"customerId": this.cipherText.aesEncrypt(this.commonService.get('userId1'), undefined, undefined, 'cbc'),
				"lob": this.cipherText.aesEncrypt('SEC', undefined, undefined, 'cbc'),
                "mode": this.cipherText.aesEncrypt(this.commonService.get('userType') == 'FAN' && '3' ||  this.commonService.get('userType') == 'SUB BROKER' && '4',undefined,undefined,'cbc'),
			}
			
			let obj = {
				'Authorization': `Bearer ${this.commonService.get('jwt_token')}`,
				'Content-Type': 'application/json'
			};
			const config = {
				url: this.easyRewards.url,
			} 
			return this.sendReqTOServer(params, config,obj)
		}

		public getVenderAuth(userId: any, accessToken: string): Observable<any> {
			const params = {
				userId: userId,
				vendor: 'sjRtKKhEf3egIhl'
			};

			const obj = {
				'Authorization': `Bearer ${accessToken}`,
				'Content-Type': 'application/json',
				'osName': 'MOBANDROID'
			};

			const config = {
				url: this.vendorAuthorize.url,
			};

			return this.sendReqTOServer(params, config, obj);
		}

		sendReqTOServerGet(params:any,config:any,reqHead:any): Observable<{}>{ 
		return this.httpClient.post('/api/secure/common-all-service-get', {
			params,
			config,
			reqHead
		})
	}
	public GetPendingPledgeRequestsStatus(cookieValue: any, clientId: any): Observable<{}> {
			let checkSumKey = this.cipherText.generateCheckSumKey();
			let stringValue = `${clientId}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
			const clientID = this.cipherText.createChecksum(clientId ,checkSumKey);
		let params = {
			"head": {
					"RequestCode": "CVUpdateLead01",
					"Key": "",
					"AppName": "AAA",
					"AppVer": "01",
					"OsName": "Android",
					"CheckSum": stringValue,
					"CheckSumKey":checkSumKey
			},
			"body": {
				"ClientCode": clientID
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookieValue) {
			obj['token'] = cookieValue;
		}
				const config = {
				url: this.PendingPledgeRequests.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				CheckSum:true

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}
	public GetSubmitPledgeTransactionForRiskApproval(cookieValue: any,  passObj: any): Observable<{}> {
		let checkSumKey = this.cipherText.generateCheckSumKey();
		let stringValue = `${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
		const encryptedBody = passObj.map((item: any) => ({
			ClientCode: this.cipherText.createChecksum(item.ClientCode, checkSumKey),
			ISIN: this.cipherText.createChecksum(item.ISIN, checkSumKey),
			TransactionID: this.cipherText.createChecksum(item.TransactionID, checkSumKey),
			Depository: this.cipherText.createChecksum(item.Depository, checkSumKey),
			SubmittedBy: this.cipherText.createChecksum(item.SubmittedBy, checkSumKey)
		}));
		let params = {
			"head": {
					"RequestCode": "CVUpdateLead01",
					"Key": "",
					"AppName": "AAA",
					"AppVer": "01",
					"OsName": "Android",
					"CheckSum": stringValue,
					"CheckSumKey":checkSumKey
			},
			"body": encryptedBody
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookieValue) {
			obj['token'] = cookieValue;
		}
				const config = {
				url: this.SubmitPledgeTransactionForRiskApproval.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				CheckSum:true

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public getcaptureRetentionMailerRequest = (cookieValue:any, passObj: any): Observable<{}> => {
    	let checkSumKey = this.cipherText.generateCheckSumKey();
		let stringValue = `${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
		// Encrypt fields for each item in the array
		const encryptedBody = passObj.map((item: any) => ({
			ClientCode: this.cipherText.createChecksum(item.ClientCode, checkSumKey),
			PartnerCode: this.cipherText.createChecksum(item.PartnerCode, checkSumKey),
			DematAccountNumber: this.cipherText.createChecksum(item.DematAccountNumber, checkSumKey),
			TargetAccountDPName: item.TargetAccountDPName,
			DateOfReceipt: this.cipherText.createChecksum(item.DateOfReceipt, checkSumKey)
		}));
		
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppVer": "01",
				"AppName": 'AAA',
				"OsName": "Android",
				"CheckSum": stringValue,
				"CheckSumKey":checkSumKey
			},
			"body": encryptedBody
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookieValue) {
			obj['token'] = cookieValue;
		}
				const config = {
				url: this.captureRetentionMailerRequest.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				CheckSum:true

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public GetRetentionMailerRequestStatus = (cookieValue:any, passObj: any,userId:any): Observable<{}> => {
	let checkSumKey = this.cipherText.generateCheckSumKey();
		let stringValue = `${passObj.fromDate}_${passObj.toDate}_${userId}_${passObj.sortBy || 'DateOfReceipt'}_${passObj.sortOrder}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
		const partnerCode = this.cipherText.createChecksum(userId, checkSumKey);
		let params = {
			"head": {
				"RequestCode": "CVUpdateLead01",
				"Key": "",
				"AppVer": "01",
				"AppName": 'AAA',
				"OsName": "Android",
				"CheckSum": stringValue,
				"CheckSumKey":checkSumKey
			},
			"body": {
				"FromDate": passObj.fromDate,
				"ToDate": passObj.toDate,
				"PartnerCode": partnerCode,
				"SearchBy": passObj.searchBy || "",
				"TargetAccountDPName": passObj.TargetAccountDPName ? passObj.TargetAccountDPName : "",
				"SearchText": passObj.searchText || "",
				"SortBy": passObj.sortBy || "DateOfReceipt",
				"SortOrder": passObj.sortOrder
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookieValue) {
			obj['token'] = cookieValue;
		}
				const config = {
				url: this.retentionMailerRequestStatus.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				CheckSum:true

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

	public GetPartnerInfoReport(cookieValue: any, userID:any, partnerID:any,): Observable<{}> {
			let checkSumKey = this.cipherText.generateCheckSumKey();
			let stringValue = `${userID}_${partnerID}_${checkSumKey}_${moment(new Date()).format('DDMMYYYY')}`;
			const LoginId = this.cipherText.createChecksum(userID , checkSumKey);
			const partnerId = this.cipherText.createChecksum(partnerID , checkSumKey);
		let params = {
			"head": {
					"RequestCode": "CVUpdateLead01",
					"Key": "",
					"AppName": "AAA",
					"AppVer": "01",
					"OsName": "Android",
					"CheckSum": stringValue,
					"CheckSumKey":checkSumKey
			},
			"body": {
				"LoginID":LoginId,
				"PartnerCode":partnerId,
			}
		}
		let obj: any = {
			'Ocp-Apim-Subscription-Key' : "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookieValue) {
			obj['token'] = cookieValue;
		}
				const config = {
				url: this.PartnerInfoReport.url,
				subKey:'AAA_OCP',
				bodyHead:{
					Key: 'Verify_Guest_And_ExtendedApi',
				CheckSum:true

				}
			} 
			return this.sendReqTOServer(params, config,obj)
	}

}
